<template>
    <div>
        <MenuPage />
    </div>
    <br><br><br><br>
    <div v-if="orden && orden.cliente">
        <div class="contenido">
            <p style="font-size: 1rem; font-weight: bold; text-align: center;">{{ orden.cliente }}</p>
            <p style="font-size: 0.8rem; font-weight: bold; color:gray; text-align: center;">{{ orden.producto }}</p>
        </div>
        <div class="formulario">
            <div v-for="(item, index) of orden.cantidad" :key="index">
                <div class="cont-100">
                    <div class="d-flex">
                        <div class="cont-15 m-auto">
                            <div class="circle">{{ index + 1 }}</div>
                        </div>
                        <div class="cont-85 m-auto">
                            <FloatLabel variant="on" class="cont-95">
                                <InputText id="on_label" class="cont-100" v-model="contenido[index]"
                                    @change="VerificarCampo(index)" />
                                <label for="on_label">Id</label>
                            </FloatLabel>
                        </div>
                    </div>
                </div>
                <br>
            </div>
        </div><br>
        <div v-if="errno === false || orden.cantidad !== items.length">
            <div class="start-btn cont-90 m-auto text-center disabled">Tomar evidencia</div>
        </div>
        <div v-if="errno === true & orden.cantidad === items.length">
            <input id="file" type="file" style="display: none;" accept="image/*" @change="LoadFile()" capture="camera">

            <label for="file" class="start-btn cont-90 m-auto text-center active" 
                v-if="evidencia_show === false">
                Tomar evidencia
            </label>
            <button class="start-btn active cont-90 m-auto" @click="UploadService()" v-else>
                Despachar Orden
            </button>
        </div>
    </div>
</template>

<script setup>
// import api from '@/plugins/axios';
import { FloatLabel, InputText } from 'primevue';
import MenuPage from './MenuPage.vue';
import { ref, onMounted } from 'vue';
import api from '@/plugins/axios';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';

const orden = ref(null);
const evidencia_show = ref(false);

const webpFile = ref(null) // aquí guardaremos el archivo optimizado
const contenido = ref([]);
const toast = useToast();
const router = useRouter();
const errno = ref(false);
const items = ref([]);

const LoadFile = () => {
    let e = event || window.event;
    const file = e.target.files[0]
    if (!file) return

    const img = new Image()
    const reader = new FileReader()

    reader.onload = (event) => {
        img.src = event.target.result
    }
    img.onload = () => {
        // Ajusta el tamaño máximo (ej: 800px de ancho)
        const maxWidth = 800
        const scale = Math.min(maxWidth / img.width, 1)
        const canvas = document.createElement('canvas')
        canvas.width = img.width * scale
        canvas.height = img.height * scale

        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        // Convertir a WebP calidad 0.8
        canvas.toBlob(
            (blob) => {
                // Creamos un archivo tipo File
                webpFile.value = new File([blob], file.name.replace(/\.[^.]+$/, '') + '.webp', {
                    type: 'image/webp',
                })
                console.log('Archivo WebP listo:', webpFile.value)
                evidencia_show.value = true;
            },
            'image/webp',
            0.8
        )
    }
    reader.readAsDataURL(file)
}

const UploadService = async () => {
    if (!webpFile.value) return
    let formData = new FormData()
    formData.append('image', webpFile.value)
    formData.append('id_operador', localStorage.getItem("id"));
    formData.append('id_orden', orden.value.Id);
    formData.append("items", JSON.stringify(contenido.value));
    try {
        const res = await api.post('/orden/uploadservice', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        console.log(res.data)
        if (res.data.response === "success") {
            toast.success("Ingreso de datos correcto");
            setTimeout(() => {
                router.push("/Operador");
            }, 1000);
        }
    } catch (err) {
        console.error(err)
    }
}

const VerificarCampo = async (index) => {
  try {
    const valor = contenido.value[index]?.trim();
    if (!valor) return;

    // --- 1️⃣ Verificar duplicado local ---
    const duplicado = contenido.value.findIndex((item, idx) =>
      idx !== index && item.trim() === valor
    );

    if (duplicado !== -1) {
      toast.warning("El ID que digitaste ya existe en tu lista");
      items.value[index] = false;
      errno.value = false; // ❌ no puede avanzar
      return;
    }

    // --- 2️⃣ Verificar en el backend ---
    const res = await api.post("/almacen/verificarcode", { numero: valor });

    if (res.data.length !== 0) {
      toast.error("No puedes registrar un número que está en almacén");
      items.value[index] = false;
      errno.value = false; // ❌ no puede avanzar
      return;
    }

    // --- 3️⃣ Si pasa ambas verificaciones ---
    items.value[index] = true;

    // --- 4️⃣ Verificar si todos los campos son válidos ---
    const algunInvalido = items.value.some(it => it === false);
    errno.value = !algunInvalido; // ✅ puede avanzar solo si todos son válidos
    console.log(items.value.length)

  } catch (err) {
    console.error(err);
    toast.error("Ocurrió un error al verificar el código");
    items.value[index] = false;
    errno.value = false;
  }
};

onMounted(() => {
    orden.value = JSON.parse(localStorage.getItem("orden"));
    console.log(orden.value);
});

</script>

<style scoped>
/* Contenedor scrollable */
.contenido {
    width: 90%;
    padding: 10px;
    margin: auto;
    overflow-y: scroll;
    background: white;
    box-shadow: 0px 4px 4px silver;
}

.disabled {
    background: rgb(211, 211, 211);
    color: gray;
}

.formulario {
    width: 90%;
    height: 63vh;
    margin: auto;
    overflow-y: scroll;
    background: white;
    box-shadow: 0px 4px 4px silver;
}

.circle {
    width: 30px;
    height: 30px;
    background-color: #0d6efd;
    color: white;
    border: none;
    font-size: 14px;
    display: block;
    padding: 8px;
    text-align: center;
    margin: auto;
    border-radius: 50%;
}

.active {
    background-color: #0d6efd;
    color: white;
}

.start-btn {

    border: none;
    border-radius: 8px;
    padding: 1rem;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
    display: block;
    transition: background-color 0.2s ease;
}

.active:hover {
    background-color: #0b5ed7;
}
</style>